import {
  _primaryControls,
  _increment,
  orderNumber,
  orderDate,
  status,
  customerName,
  // eslint-disable-next-line
  area_id,
} from '@/table/delivery/base';

export default {
  types: {
    // _primaryControls,
    _selectorControls: {
      width: '2rem',
      name: 'SELECT',
    },
    _increment,
    deliveryNote: {
      name: 'เลขที่ใบจัดรถ',
      width: '9rem',
      class: 'text-center',
      // eslint-disable-next-line
      filter: (val: any, row: any) =>  val?.uniqueId ? val.uniqueId : '',
    },
    orderNumber,
    orderDate,
    status,
    customerName,
    // eslint-disable-next-line
    area_id,
    'packages.length': {
      name: 'จำนวนรายการ',
      width: '1fr',
      class: 'text-center',
    },
  },
  sortable: [
    'orderNumber',
    'orderDae',
    'status',
    'customerName',
  ],
};
